// extracted by mini-css-extract-plugin
module.exports = {"statusSuccess":"onboardingTemplate_statusSuccess__23GcF","confirmIcon":"onboardingTemplate_confirmIcon__3LAOG"};